<template>
  <el-popover
    v-if="help"
    placement="left"
    width="340"
    trigger="click"
    popper-class="attr-help-popper"
  >
    <div class="attr-help-body">
      <div v-if="help.title" class="attr-help-title">{{ $tt(help.title) }}</div>
      <div class="attr-help-desc">{{ $tt(help.desc) }}</div>
      <div v-if="help.usage" class="attr-help-meta">
        <span class="k">{{ $tt("用法") }}</span>{{ $tt(help.usage) }}
      </div>
      <div v-if="help.impact" class="attr-help-meta">
        <span class="k">{{ $tt("影响") }}</span>{{ $tt(help.impact) }}
      </div>
    </div>
    <span
      class="attr-help-dot"
      slot="reference"
      :title="$tt((help && help.title) || '功能说明')"
      @click.stop
    />
  </el-popover>
</template>

<script>
import { getAttrHelp } from "@/utils/attrHelpMap";

export default {
  name: "AttrHelpDot",
  props: {
    /** 属性/功能 key，或 event.xxx / section.xxx */
    helpKey: {
      type: String,
      default: "",
    },
    /** 当前组件类型，用于更精确匹配 */
    component: {
      type: String,
      default: "",
    },
    /** 直接传入文案对象，优先于 helpKey 查找 */
    helpData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    help() {
      if (this.helpData && this.helpData.desc) {
        return this.helpData;
      }
      return getAttrHelp(this.helpKey, this.component);
    },
  },
};
</script>

<style lang="scss">
.attr-help-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background: #e8b84a;
  vertical-align: middle;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(232, 184, 74, 0.28);
  &:hover {
    background: #f0c65c;
  }
}
.attr-help-popper {
  .attr-help-body {
    font-size: 12px;
    line-height: 1.55;
    color: #303133;
    white-space: pre-wrap;
  }
  .attr-help-title {
    font-weight: 600;
    margin-bottom: 6px;
    font-size: 13px;
  }
  .attr-help-desc {
    margin-bottom: 8px;
    color: #606266;
  }
  .attr-help-meta {
    margin-top: 6px;
    color: #606266;
    .k {
      display: inline-block;
      min-width: 32px;
      margin-right: 4px;
      color: #909399;
    }
  }
}
</style>
